import Base from '@/resources/Base'

export default class ProcessLineage extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)

    if (this.processLineageEvents) {
      // backend returns newest first,
      // we want to display oldest first
      if (!_.isEmpty(this.processLineageEvents)) {
        this.reverse()
      }
      this.processLineageEvents.forEach(processEvent => {
        this.transformV2Events(processEvent)
      })
    } else {
      this.processLineageEvents = []
    }
  }

  /**
   *  V2 events metadata info are return inside field 'proc'.
   *  proc is a copy of WindowsProc or LinuxProc depending on os.
   *  Merge interested fields into higher object property level to match V1.
   *
   * @param {*} processEvent
   */
  transformV2Events (processEvent) {
    if (processEvent.version || processEvent.version > 1) {
      let osProc = 'windowsProc'
      processEvent.os = processEvent.os ? processEvent.os.toLowerCase() : processEvent.os

      if (processEvent.os === 'linux') {
        osProc = 'linuxProc'
      }

      let eventProc = processEvent[osProc]
      _.merge(processEvent, {
        comm: eventProc.comm,
        starttime: eventProc.id.starttime,
        pid: eventProc.id.pid,
        ppid: eventProc.ppid,
        filename: eventProc.filename,
        flattenedArgv: _.isArray(eventProc.argv) ? eventProc.argv.join(' ') : eventProc.argv,
        sid: eventProc.sid,
        logonUser: eventProc.windowsSubject ? eventProc.windowsSubject.winUser : '',
        logonId: eventProc.windowsSubject ? eventProc.windowsSubject.winUserId : '',
        uid: eventProc.uid,
        euid: eventProc.euid,
        sessionid:
          _.isNumber(eventProc.auditSessionId) && parseInt(eventProc.auditSessionId) > -1
            ? eventProc.auditSessionId
            : ''
      })
    }
  }

  reverse () {
    this.processLineageEvents.reverse()
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/ProcessLineage.js